import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { selectVoucherTypesMap } from '@debbie/cortex/dist/economy/selectors';
import { Money, Well } from '../..';
import { sum } from '../../../utils';
import ArrowDownCircle from '../../Icons/ArrowDownCircle';
import CornerDownRight from '../../Icons/CornerDownRight';
import Voucher from './Voucher';
const Type = (props) => {
    const lang = useSelector((s) => s.lang);
    const voucherTypesMap = useSelector(selectVoucherTypesMap);
    const [openTypes, setOpenTypes] = useState(Array.from(new Set(props.caseVouchers.map((caseVoucher) => caseVoucher.voucherTypeId))).reduce((acc, type) => {
        acc[type] = false;
        return acc;
    }, {}));
    const vouchersOfType = props.newCategories[props.category].caseVouchers[props.voucherType];
    const voucherProps = {
        deletable: props.deletable,
        category: props.category,
        caseVouchers: props.caseVouchers,
        singleCase: props.singleCase,
        setDepositCaseVoucherHovored: props.setDepositCaseVoucherHovored,
        depositCaseVoucherHovored: props.depositCaseVoucherHovored,
    };
    if (vouchersOfType.length === 1)
        return (React.createElement(Voucher, Object.assign({ level: props.level, caseId: props.caseId, caseVoucher: vouchersOfType[0], parent: vouchersOfType[0].children.length > 0 }, voucherProps)));
    const children = props.newCategories[props.category].caseVouchers[props.voucherType]
        .filter((voucher) => voucher.children.length > 0)
        .map((voucher) => voucher.children)
        .reduce((acc, vouchers) => acc.concat(vouchers), []);
    const voucherType = voucherTypesMap
        ? voucherTypesMap[props.voucherType]
        : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledType, { parent: props.newCategories[props.category].caseVouchers[props.voucherType].filter((caseVoucher) => caseVoucher.children.length > 0).length > 0, small: false, style: { cursor: 'pointer', userSelect: 'none' }, onClick: () => setOpenTypes(Object.assign(Object.assign({}, openTypes), { [props.voucherType]: !openTypes[props.voucherType] })) },
            React.createElement(SpaceBetween, null,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement(ArrowDownCircle, { style: {
                            transform: `rotate(${openTypes[props.voucherType] ? '0deg' : '-90deg'})`,
                            height: '1em',
                            width: '1em',
                            transition: 'transform 0.2s',
                            marginRight: '.5em',
                        } }),
                    vouchersOfType.length > 1 &&
                        `${vouchersOfType.filter((cv) => cv.deletedAt == null).length} `,
                    (vouchersOfType.filter((cv) => cv.deletedAt == null).length === 1
                        ? lang.economyVoucherTypeLabels[props.voucherType]
                        : lang.pluralEconomyVoucherTypeLabels[props.voucherType]) || (voucherType === null || voucherType === void 0 ? void 0 : voucherType.label)),
                React.createElement(Money, { color: ['transaction'].indexOf(props.category) != -1, amount: props.newCategories[props.category].caseVouchers[props.voucherType]
                        .filter((v) => !v.deletedAt)
                        .map((v) => v.amount)
                        .reduce(sum, 0) })),
            children.length > 0 && (React.createElement(StyledType, { parent: false, small: true, style: { cursor: 'pointer', userSelect: 'none' }, onClick: () => setOpenTypes(Object.assign(Object.assign({}, openTypes), { [props.voucherType]: !openTypes[props.voucherType] })) }, Object.entries(children.reduce((acc, child) => {
                acc[child.voucherTypeId] = (acc[child.voucherTypeId] || []).concat(child);
                return acc;
            }, {})).map(([voucherTypeId, _children]) => (React.createElement(SpaceBetween, { key: voucherTypeId },
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    React.createElement(CornerDownRight, { style: {
                            margin: '-0.1em 0.3em 0 0.3em',
                        } }),
                    lang.pluralEconomyVoucherTypeLabels[voucherTypeId] || (voucherType === null || voucherType === void 0 ? void 0 : voucherType.label)),
                React.createElement("div", null,
                    React.createElement(Money, { color: ['transaction'].indexOf(props.category) != -1, amount: _children
                            .filter((caseVoucher) => !caseVoucher.deletedAt)
                            .map((v) => v.amount)
                            .reduce(sum, 0) })))))))),
        openTypes[props.voucherType] && (React.createElement(Well, { style: { fontSize: '0.8em', padding: '10px 20px' } }, vouchersOfType
            .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map((caseVoucher) => (React.createElement(Voucher, Object.assign({ key: caseVoucher.caseVoucherId, level: 2, caseVoucher: caseVoucher, caseId: props.caseId, parent: caseVoucher.children.length > 0 }, voucherProps))))))));
};
export default Type;
const StyledType = styled.div `
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
  margin: 0;
  font-weight: normal;
  padding: ${(props) => props.small
    ? '0em 0 0.2em 1.9em'
    : props.parent
        ? '0.2em 0 0.2em 0em'
        : '0.2em 0 0.2em 0em'};
  font-size: ${(props) => (props.small ? '0.8em' : '1em')};
`;
const SpaceBetween = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
//# sourceMappingURL=Type.js.map